import _ from 'lodash'
import axios from 'axios-legacy'
import transformKeys from 'transform-keys'
import defaultsConfig from 'axios-legacy/lib/defaults'

import { getAccessTokenId } from 'auth'

import { API_URL } from 'config'

export function formCfg(params, context, config) {
  return {
    params: {
      ...params,
      __context: context ? JSON.stringify(transformRequest(context)) : null,
    },
    ...config,
  }
}

export function listDehydrate(data, dehydrateFn) {
  if (data.results) {
    return {
      count: data.count,
      results: _.map(data.results, dehydrateFn),
    }
  }

  return _.map(data, dehydrateFn)
}

export function memoize(func) {
  let memo = {}

  return (...args) => {
    const key = JSON.stringify(args)

    if (key in memo) {
      return memo[key]
    }

    return (memo[key] = func.apply(this, args))
  }
}

function transformRequest(data) {
  if (data) {
    data = transformKeys(data, _.snakeCase)
  }

  return data
}

function transformResponse(data) {
  if (data) {
    data = transformKeys(data, _.camelCase)
  }

  return data
}

const api = axios.create({
  baseURL: API_URL,
  timeout: 90000,
  headers: {},
  xsrfHeaderName: 'X-CSRFToken',
  xsrfCookieName: 'csrftoken',
  transformRequest: [transformRequest, defaultsConfig.transformRequest[0]],
  transformResponse: [defaultsConfig.transformResponse[0], transformResponse],
})

api.interceptors.request.use(async function (config) {
  const token = await getAccessTokenId()

  const headers = token
    ? { ...config.headers, authorization: `Bearer ${token}` }
    : config.headers

  return {
    ...config,
    headers,
  }
})

export default api
